import './wgl-csr.css';

import { FormRenderer } from '@wegolook/schema-form-renderer';
import React, { Component } from 'react';

class WGLCSRContext extends Component {
  render() {
    return (
      <FormRenderer
        {...this.props}
        schema={this.props.editSchemaSchema}
        formValue={this.props.editSchemaPreview}
        onChange={this.props.onChange}
        renderContext="wgl-csr"
      />
    );
  }
}

export default WGLCSRContext;
